import LogoYaGamePage from '../pages/LogoYaGamePage';
import LogoYaProductPage from '../pages/LogoYaProductPage';

export const logoYaRoutes = [
  {
    path: 'logo-ya',
    element: <LogoYaGamePage />,
  },
  {
    path: 'logo-ya/producto',
    element: <LogoYaProductPage />,
  },
];
